import { render } from "./AutoComplete.vue?vue&type=template&id=20f7b15e&scoped=true"
import script from "./AutoComplete.vue?vue&type=script&lang=js"
export * from "./AutoComplete.vue?vue&type=script&lang=js"

import "./AutoComplete.vue?vue&type=style&index=0&id=20f7b15e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f7b15e"]])

export default __exports__